import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordAttributionV1Body } from './record-attribution-v1-request';
import type { IRecordAttributionV1Response } from './record-attribution-v1-response';
import { recordAttributionV1ResponseSchema } from './record-attribution-v1-response';

export async function recordAttributionV1Api(
  body: IRecordAttributionV1Body,
): Promise<IValidatedResponse<IRecordAttributionV1Response>> {
  return postRequest<IRecordAttributionV1Response>({
    path: '/account/attribution/v1',
    body,
    schema: recordAttributionV1ResponseSchema,
  });
}
